<template>
  <a-modal
    :title="status == 1 ? '详情' : '编辑'"
    style="top: 20px"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :maskClosable="false"
    :footer="null"
  >
    <a-form :form="form" :class="status == 1 ? 'readyOnly' : ''">
      <a-form-item style="display: none" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['sourceId']" />
      </a-form-item>
      <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-decorator="['installType', { rules: [{ required: true, message: '请选择安装类别' }] }]">
          <a-select-option v-for="type in restaurantTypes" :key="type.code">{{ type.label }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          showSearch
          optionFilterProp="children"
          @change="handleChange"
          :filterOption="filterOption"
          v-decorator="['enterpriseId', { rules: [{ required: true, message: '请选择企业名称' }] }]"
          :disabled="istrue"
        >
          <a-select-option v-for="item of data" :key="item.enterpriseId" :value="item.enterpriseId">{{
            item.enterpriseName
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="信息来源名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['sourceName', { rules: [{ required: true, message: '请输入信息来源名称' }] }]" />
      </a-form-item>
    </a-form>
    <a-row :class="status == 1 ? 'readyOnly' : ''" v-if="status != 1">
      <a-col :span="12" :offset="10">
        <a-button type="primary" @click="handleSubmit">保存</a-button>
        <a-button style="margin-left: 8px" @click="showModal">取消</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import { saveSource, getSlectCombox } from '@/api/enterprise/source'
import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'

export default {
  name: 'SourceModal',
  props: {},
  components: {},
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      restaurantTypes: [],
      data: [],
      queryParam: {},
      istrue: false,
      enterId: '',
      status: 0,
    }
  },
  beforeCreate() {},
  async created() {
    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({ code: key, label: value })
    })
    // isAuthority 1   数据隔离
    getSlectCombox({ isAuthority: 1 }).then((res) => {
      // console.log(res.data)
      this.data = res.data
    })
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange(value) {
      // console.log(`selected ${value}`)
      this.queryParam.enterpriseId = value
    },
    showModal() {
      this.visible = !this.visible
    },
    add(enterId) {
      this.enterId = enterId
      this.form.resetFields()
      this.edit({ sourceId: 0 })
    },
    edit(record, status) {
      this.status = status
      this.mdl = Object.assign(record)
      this.visible = true
      if (this.enterId != '') {
        this.$nextTick(() => {
          this.form.setFieldsValue({ sourceId: this.mdl.sourceId, enterpriseId: this.enterId })
          this.istrue = true
        })
      } else {
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(this.mdl, 'sourceId', 'sourceName', 'installType', 'enterpriseName', 'enterpriseId')
          )
        })
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          this.confirmLoading = true
          // values.sourceId=0
          console.log(values.sourceId)
          saveSource(values)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                if (values.sourceId == 0) {
                  this.$emit('ok', 1)
                } else {
                  this.$emit('ok', 2)
                }
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
.readyOnly {
  pointer-events: none;
}
</style>
